import styled, { css } from 'styled-components';

import { Card, useFullscreenContext } from '@pega/cosmos-react-core';

export const StyledFullscreenCard = styled(Card)(({ theme }) => {
  const fullscreen = useFullscreenContext();

  return css`
    width: ${fullscreen?.[0] ? null : theme.base['content-width'].md};
  `;
});
